import { useState, type FormEvent } from 'react'
import { login } from '../api'

interface Props {
  onLoggedIn: () => void
  onTotpRequired: (continuationToken: string) => void
}

export function Login({ onLoggedIn, onTotpRequired }: Props) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [loading, setLoading] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setLoading(true)
    const result = await login(username, password)
    setLoading(false)
    if ('error' in result) {
      setError(result.error === 'rate_limited' ? 'Too many attempts. Try again later.' : 'Incorrect username or password')
      return
    }
    if ('requiresTotp' in result) {
      onTotpRequired(result.continuationToken)
      return
    }
    onLoggedIn()
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <div className="text-3xl font-light tracking-tight mb-2">Ross Ultrix</div>
          <div className="text-sub text-sm">Sign in to control the router</div>
        </div>

        <div className="space-y-3">
          <input
            autoFocus
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder="Username"
            className="w-full bg-panel border border-border rounded-md px-4 py-3 text-ink placeholder:text-sub focus:outline-none focus:border-accent"
            autoComplete="username"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="w-full bg-panel border border-border rounded-md px-4 py-3 text-ink placeholder:text-sub focus:outline-none focus:border-accent"
            autoComplete="current-password"
          />
        </div>

        {error && <div className="text-err text-sm text-center">{error}</div>}

        <button
          type="submit"
          disabled={loading || !username || !password}
          className="w-full bg-accent text-white font-medium py-3 rounded-md disabled:opacity-50"
        >
          {loading ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
    </div>
  )
}
